__webpack_require__.p = "https://my.dev.id.myob.com/";